import styled from 'styled-components';
import { Paragraph } from 'src/common/components/typography/Text';

// todo: should be unified with application headings
export const RequestProductSectionParagraph = styled(Paragraph)`
  margin-top: 0;
  margin-bottom: 2rem;
  line-height: 1.25;
`;
